import styled from 'styled-components'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Text from '../../atoms/Text';

const Container = styled.header`
  width: 100%;
  max-width: 600px;
  height: 56px;
  background-color: ${(props) => props.theme.colors.neutral[100]}; 
  border-bottom: 2px solid ${(props) => props.theme.colors.neutral[300]}; 
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 800;
`
const Title = styled(Text)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 500;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
`
const BackIcon = styled(ArrowBackIcon)`
  color: ${(props) => props.theme.colors.text.normal};
`
const MenuIcon = styled(MoreVertIcon)`
  color: ${(props) => props.theme.colors.text.normal};
`

const SubHeader = ({ variant, title, onBack, onMenuClick }) => {
  return (
    <Container>
      <IconButton onClick={onBack}>
        <BackIcon/>
      </IconButton>
      {title && <Title weight="medium">{title}</Title>}
      {variant === "action" && 
        <IconButton onClick={onMenuClick}>  
          <MenuIcon/>
        </IconButton>
      }
    </Container>
  )
}

export default SubHeader
